<template>
  <v-dialog v-model="add" persistent max-width="370" class="mx-1">
    <v-btn dark color="red lighten-1" small slot="activator">
      <v-icon>add</v-icon> Новый номер телефона
    </v-btn>
    <v-card>
      <v-toolbar flat>
        Новый номер
        <v-spacer></v-spacer>
        <v-btn flat icon @click.native="add = false; newphone = null; confirmation = null">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          label="телефон"
          v-model="newphone"
          :disabled="confirmation !== null"
        ></v-text-field>
        <v-text-field
          v-if="confirmation !== null"
          label="код подтверждения из SMS"
          v-model="confirmation"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat
          @click.native="add = false; newphone = null; confirmation = null"
        >
          Отмена
        </v-btn>
        <v-btn v-if="confirmation === null" color="primary" flat
          @click.native="addPhone"
          :disabled="false === validPhone"
        >
          Продолжить
        </v-btn>
        <v-btn v-else color="primary" flat
          @click.native="confirmPhone"
          :disabled="false === validConfirmation"
        >
          Продолжить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const phoneRe = /^7\d{10}$/g
export default {
  name: 'new-phone-dialog',
  props: ['profile'],
  data: () => ({
    add: false,
    newphone: null,
    confirmation: null,
    confirmationid: null,
    serv: {}
  }),
  methods: {
    async addPhone () {
      try {
        const { meta, confirmationid } = await this.$store.dispatch('sioRequest', {
          topic: 'phones-create-request',
          pl: { phone: this.newphoneTrimmed }
        })
        this.$store.dispatch('snack', meta.msg)
        this.confirmationid = confirmationid
        this.confirmation = ''
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async confirmPhone () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'phones-create-confirm',
          pl: { secret: this.confirmation, confirmationid: this.confirmationid }
        })
        this.$emit('added')
        this.confirmation = null
        this.confirmationid = null
        this.newphone = null
        this.add = false
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    validPhone () {
      return phoneRe.test(String(this.newphoneTrimmed).toLowerCase())
    },
    validConfirmation () {
      return /^\d{5}$/g.test(this.confirmation)
    },
    newphoneTrimmed () {
      if (!this.newphone) return
      return this.newphone.split(/\D/).join('').replace(/^8/, 7)
    }
  }
}
</script>

<style lang="css">
</style>
